import{ComponentTypes as A}from"../types/componentTypes.js";const D={[A.SIDE_MODAL]:10,[A.MODAL]:11,[A.STYLED_MODAL]:11,[A.STATE_MODAL]:12,[A.FEATURE_MODAL]:12,[A.TOASTER]:13};export{D as ComponentZindex};
